module.exports = __webpack_public_path__ + "img/en-vivo-banner.4f4fbe88.png";